import { render, staticRenderFns } from "./RibbonBand.vue?vue&type=template&id=61af0982&"
import script from "./RibbonBand.vue?vue&type=script&lang=js&"
export * from "./RibbonBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports